import { Link } from "react-router-dom";
import { HandHeart, ArrowRight } from "@phosphor-icons/react";

// Prominent promo linking to the "Your Alma Mater Still Needs You" article.
// Used on Alumni Groups, Institutions directory, and individual group/institution pages.
export default function AlmaMaterPromo({ compact = false, className = "" }) {
  return (
    <Link
      to="/articles/your-alma-mater-still-needs-you"
      data-testid="alma-mater-promo"
      className={`group block overflow-hidden rounded-2xl border border-secondary/30 bg-gradient-to-r from-green-50 via-white to-orange-50 transition-all hover:shadow-md ${className}`}
    >
      <div className={`flex items-center gap-4 ${compact ? "p-4" : "p-5 sm:p-6"}`}>
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary/15 text-secondary sm:h-14 sm:w-14">
          <HandHeart size={compact ? 24 : 30} weight="duotone" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <span className="rounded-full bg-secondary/15 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-secondary">Alumni Impact</span>
          </div>
          <h3 className="mt-1 font-heading text-lg font-medium leading-tight text-foreground sm:text-xl">
            Your Alma Mater Still Needs You
          </h3>
          {!compact && (
            <p className="mt-0.5 line-clamp-2 text-sm text-muted-foreground">
              Institutions share what's happening and what they need — alumni give time, knowledge, mentoring, equipment or funds, and earn recognition for giving back.
            </p>
          )}
        </div>
        <span className="hidden shrink-0 items-center gap-1 text-sm font-medium text-secondary transition-transform group-hover:translate-x-0.5 sm:inline-flex">
          Read <ArrowRight size={16} />
        </span>
      </div>
    </Link>
  );
}
